class SliderRecommend {
    constructor(item) {
        // Переменные
        this.element = item;
        this.slider = this.element.querySelector('.js-slider');
        this.btnPrev = this.element.querySelector('.js-gallery-prev');
        this.btnNext = this.element.querySelector('.js-gallery-next');

        // Функции
        this.setListeners();
    };

    setListeners() {
        if (window.innerWidth >= 1024) {
            const swiper = new Swiper(this.slider, {
                slidesPerView: 4,
                spaceBetween: 40,
                breakpoints: {
                    320: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 28,
                    },
                    1280: {
                        spaceBetween: 40,
                    }
                },
                navigation: {
                    nextEl: this.btnNext,
                    prevEl: this.btnPrev,
                },
            });
        }
    }
};

document.querySelectorAll('.js-slider-popular').forEach((item) => new SliderRecommend(item));
